export default "__VITE_ASSET__B81eICOP__"